<!-- src/components/UnsavedChangesDialog.vue -->
<template>
  <Teleport to="body">
  <div v-if="show" class="fixed inset-0 z-[350] flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black opacity-50"></div>

    <!-- Dialog -->
    <div class="relative bg-white rounded-lg shadow-xl w-full max-w-md p-6 z-10 m-4">
      <!-- Icon -->
      <div class="flex justify-center mb-4">
        <div class="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center">
          <svg class="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
            </path>
          </svg>
        </div>
      </div>

      <!-- Content -->
      <div class="text-center mb-6">
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          {{ title || 'Unsaved Changes' }}
        </h3>
        <p class="text-gray-600">
          {{ message || 'You have unsaved changes. Are you sure you want to close? Your changes will be lost.' }}
        </p>
      </div>

      <!-- Actions -->
      <div class="flex gap-3">
        <button
          @click="$emit('keep-editing')"
          class="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
        >
          {{ cancelText || 'Keep Editing' }}
        </button>
        <button
          @click="$emit('discard')"
          class="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium"
        >
          {{ confirmText || 'Discard Changes' }}
        </button>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useBodyScrollLock } from '../composables/useBodyScrollLock'

interface Props {
  show: boolean
  title?: string
  message?: string
  confirmText?: string
  cancelText?: string
}

const props = defineProps<Props>()
useBodyScrollLock(() => props.show)

defineEmits<{
  'keep-editing': []
  'discard': []
}>()
</script>
